import { render, staticRenderFns } from "./MessageError.vue?vue&type=template&id=c35aa5fa&scoped=true&"
import script from "./MessageError.vue?vue&type=script&lang=js&"
export * from "./MessageError.vue?vue&type=script&lang=js&"
import style0 from "./MessageError.vue?vue&type=style&index=0&id=c35aa5fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c35aa5fa",
  null
  
)

export default component.exports